<template>
  <q-timeline color="primary" responsive>
    <q-timeline-entry
      v-for="activity in mapped"
      :key="activity.id"
      :title="activity.title"
      :subtitle="activity.timePassed"
      :icon="activity.icon"
      side="left"
    >
      <div v-if="activity.description !== ''">
        {{ activity.description }}
      </div>
    </q-timeline-entry>
  </q-timeline>
</template>

<script>
  import { transformActivity } from 'src/utils/activities'

  export default {
    props: {
      activities: {
        type: Array,
        required: true
      }
    },

    computed: {
      mapped () {
        return this.activities
          .map(transformActivity)
          .sort((a, b) => a.created_at > b.created_at ? 1 : -1)
      }
    }
  }
</script>
